"use client"

import { useEffect } from "react";
import { useUser } from "../../contexts/UserContext";
import { useRouter } from "next/navigation";
import DashboardLayout from "../../components/layout/DashboardLayout";
import { QuickTips } from "../../components/dashboard/QuickTips";

export default function Dashboard() {
  const { user, loading, openLogin } = useUser();
  const router = useRouter();

  // Show login modal if not logged in
  useEffect(() => {
    if (!loading && !user) {
      openLogin();
    }
  }, [user, loading, openLogin]);

  // If loading, show loading state
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#2188FF]"></div>
      </div>
    );
  }

  return (
    <DashboardLayout user={user}>
      <div className="flex flex-col items-center justify-center h-full py-10 text-center">
        <div className="bg-gradient-to-br from-[#0969DA]/10 to-[#2188FF]/5 rounded-2xl p-8 mb-8 transform transition-all hover:scale-105">
          <svg className="w-20 h-20 text-[#2188FF] mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
          </svg>
        </div>
        <h1 className="text-4xl font-bold text-[#24292F] dark:text-white mb-4 tracking-tight">Your Journey to Confident First Commit</h1>
        <p className="text-xl text-[#57606A] dark:text-gray-300 max-w-lg mb-10">
          Import your repositories and start exploring your codebase with AI-powered insights.
        </p>
        
        <div className="w-full max-w-4xl">
          <QuickTips />
        </div>
      </div>
    </DashboardLayout>
  );
} 